export enum Gun {
  gun = "gun",
  freeze = "freeze",
  fire = "fire",
}

export enum KeyVar {
  w = "w",
  a = "a",
  s = "s",
  d = "d",
}

export type Enemy = {
  id: string;
  posX: number;
  posY: number;
  health: number;
  freeze: number;
};

export type Boxes = {
  healthBoxes: number;
  gunCartridges: number;
  fireCartridges: number;
  freezeCartridges: number;
  bomb: number;
};

export enum Box {
  level1 = "level1",
  level2 = "level2",
  level3 = "level3",
  level4 = "level4",
  level5 = "level5",
  level6 = "level6",
  level7 = "level7",
  level8 = "level8",
  level9 = "level9",
}

export type BoardBox = {
  id: string;
  posX: number;
  posY: number;
  type: Box;
};

export enum GameStatus {
  active = "active",
  paused = "paused",
}

export type PlayerSate = {
  health: number;
  posX: number;
  posY: number;
};

export type KeyActiveState = {
  [key in keyof typeof KeyVar]: boolean;
};

export type ShotCounterState = {
  [key in keyof typeof Gun]: number;
};

export type BoardState = {
  gameStatus: keyof typeof GameStatus;
  winner: boolean;
  bombs: number;
  gunShotCounter: number;
  fireShotCounter: number;
  freezeShotCounter: number;
  lastMove: keyof typeof KeyVar;
  player: {
    health: number;
    posX: number;
    posY: number;
  };
  gun: keyof typeof Gun;
  openFire: boolean;
  keyActive: {
    w: boolean;
    a: boolean;
    s: boolean;
    d: boolean;
  };
  healthBoxes: number;
  seconds: number;
  enemies: Enemy[];
  boxes: BoardBox[];
  isGameOver: boolean;
};
